export const urgencyOptions = [
    { label: 'Flexible', value: 0 },
    { label: 'Immediate (0-1 month)', value: 1 },
    { label: 'Short Term (1-3 months)', value: 2 },
    { label: 'Medium Term (3-6 months)', value: 3 },
    { label: 'Long Term (6+ months)', value: 4 },
];
